import BasePrevenApiClient from './baseApi'

/**
 * Spreadsheet bulk import of a model's records (see ADR 0008 of the
 * backend): `preview` classifies the whole sheet without writing anything
 * and `confirm` starts writing the valid rows in the background (answers
 * with the job, see `job`) and logs the import.
 */
class BulkImportApi extends BasePrevenApiClient {
  /**
   * Returns a shared api instance
   *
   * @returns {BulkImportApi} Api shared instance
   */
  static get shared() {
    return super.shared
  }

  _path(app, model, suffix = '') {
    return this._getFullPath(
      `/utilities/api/bulk-import/${app}/${model}${suffix}`
    )
  }

  _upload(app, model, action, token, file) {
    const body = new FormData()
    body.append('file', file)
    return this._post(this._path(app, model, `/${action}`), body, {
      authToken: token,
    }).then(({ data }) => data)
  }

  info(token, app, model) {
    return this._get(this._path(app, model), { authToken: token }).then(
      ({ data }) => data
    )
  }

  preview(token, app, model, file) {
    return this._upload(app, model, 'preview', token, file)
  }

  confirm(token, app, model, file) {
    return this._upload(app, model, 'confirm', token, file)
  }

  /**
   * Status of an import started by `confirm` (it runs in the background):
   * poll it until `status` is no longer `running`. Rows come with the final one.
   */
  job(token, app, model, id) {
    this._clearMemos()
    return this._get(this._path(app, model, '/logs'), {
      authToken: token,
      params: { id },
    }).then(({ data }) => data)
  }

  logs(token, app, model, page = 1) {
    // GETs are memoized in production builds: the history must be fresh.
    this._clearMemos()
    return this._get(this._path(app, model, '/logs'), {
      authToken: token,
      params: { page },
    }).then(({ data }) => data)
  }
}

export default BulkImportApi
